import {logOperationalMetric, isResponseCode5xx, getAPIGatewayPostRequest, getNodeId} from "../../../util/Util";
import {ENDPOINT_GET_BAG_LOCATION_INFO} from "../../../util/Constants";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

const metricProcessName = "BAG_LOCATION_DETAILS";

export function fetchBagLocationInfo(dispatcher) {
    const request = {
        nodeId: getNodeId()
    };
    getBagLocationInfo(dispatcher, request);
};

async function getBagLocationInfo(dispatcher, request) {
    const startTime = Date.now();
    const response = await getBagLocationInfoDetails(request.nodeId);
    const isSuccess = response.status === 200;
    const isFault = isResponseCode5xx(response.status);

    // Log operations. This adds a metric on how many HTTPS requests are successfully completed.
    logOperationalMetric(startTime, metricProcessName, "getBagLocationInfo", isSuccess, isFault);

    dispatcher({type: "RECEIVE_DATA", data: {bagList: response.data}});
};

async function getBagLocationInfoDetails(siteId) {
    const requestBody = {
        "nodeId": siteId
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_BAG_LOCATION_INFO);

    return await getAPIGatewayDataFromParent(args);
};


// WEBPACK FOOTER //
// ./src/components/devicemanagement/bagtracking/network/BagTrackingNetworkAPI.js